import { render, staticRenderFns } from "./DropdownLink.vue?vue&type=template&id=2af50310&scoped=true"
import script from "./DropdownLink.vue?vue&type=script&lang=ts"
export * from "./DropdownLink.vue?vue&type=script&lang=ts"
import style0 from "./DropdownLink.vue?vue&type=style&index=0&id=2af50310&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af50310",
  null
  
)

export default component.exports